import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PortalIdParser from 'PortalIdParser';
import UILogo from 'UIComponents/image/UILogo';
import UIMedia from 'UIComponents/layout/UIMedia';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import UIMediaLeft from 'UIComponents/layout/UIMediaLeft';
import UILink from 'UIComponents/link/UILink';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { NETWORK_LOGO } from '../../constants/ads';
import { COMPONENT, EVENT, INTERACTION_TYPE, SUB_COMPONENT } from '../../constants/tracking';
import usageTracker from '../../utils/usageTracker';
export default function AdCampaignWithIcon({
  adCampaignNetwork,
  adCampaignName,
  adAccountId,
  adCampaignId
}) {
  const handleAdCampaignClick = () => {
    usageTracker.track(EVENT.INTERACTION, {
      interactionType: INTERACTION_TYPE.ADS_GOALS_CAMPAIGN_LINK_CLICK,
      screen: COMPONENT.GOALS_TABLE,
      subscreen: SUB_COMPONENT.GOAL_DETAILS
    });
  };

  return /*#__PURE__*/_jsxs(UIMedia, {
    align: "start",
    children: [/*#__PURE__*/_jsx(UIMediaLeft, {
      className: "m-top-1",
      children: /*#__PURE__*/_jsx(UILogo, {
        height: 20,
        name: NETWORK_LOGO[adCampaignNetwork.toUpperCase()]
      })
    }), /*#__PURE__*/_jsx(UIMediaBody, {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        className: "m-top-2",
        maxWidth: 250,
        children: /*#__PURE__*/_jsx(UILink, {
          external: true,
          href: `/ads/${PortalIdParser.get()}/accounts/${adCampaignNetwork}/${adAccountId}/campaigns/${adCampaignId}`,
          onClick: handleAdCampaignClick,
          children: adCampaignName
        })
      })
    })]
  });
}